module.exports = __webpack_public_path__ + "static/img/produto_p.088ccad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-cgas/produto_p.png
// module id = JUhN
// module chunks = 0